<template>
  <td colspan="5">
    <i class="fa fa-warning mr-1 text-warning"></i> {{ message }}
  </td>
</template>

<script setup>
import { useMainStore } from '@/store'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
// define props
const props = defineProps({
  print: {
    type: Object,
    required: true
  }
})
// define computed properties
const inEnglish = computed(() => {
  return store.settings.locale === 'en'
})

const message = computed(() => {
  const attribute = (inEnglish.value) ? 'name_en' : 'name';

  return t('configurator.notices.warnings.not_bookable_print_article')
    .replace('[ARTICLE_NAME]', props.print.article[attribute])
    .replace('[ARTICLE_PRINT_NAME]', props.print.article_print[attribute])
})
</script>